import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-999"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M4.669 9 2.08 5.171H.991v6.05h1.202V7.41l2.584 3.811h1.095v-6.05H4.669V9zm8.219-3.829H11.66l-2.125 6.05h1.281l.396-1.247h2.107l.37 1.247h1.308zm-1.352 3.793.746-2.37.711 2.37zM9.29 4.98a.5.5 0 0 0-.631.317L6.88 10.661a.5.5 0 1 0 .949.315l1.778-5.364a.5.5 0 0 0-.317-.632z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }